import type { ReactNode } from 'react';

interface BaseProps { children: ReactNode; className?: string }

export function PageGrid({ children, className = '', dark = false, id, label }: BaseProps & { dark?: boolean; id?: string; label?: string }) {
  return (
    <section id={id} aria-label={label} className={`mgrid ${dark ? 'dark' : ''} ${className}`}>
      {children}
    </section>
  );
}

export function GridHalf({ children, className = '', side = 'l' }: BaseProps & { side?: 'l' | 'r' }) {
  return <div className={`${side === 'r' ? 'half-r' : 'half-l'} min-w-0 ${className}`}>{children}</div>;
}

/** Transparent opening onto the persistent visual world (no own renderer). */
export function Window({ className = '', tag, caption, meta }: { className?: string; tag?: string; caption?: string; meta?: string }) {
  return (
    <div className={`window ${className}`}>
      {tag && <span className="window-tag left-4 top-4 md:left-6 md:top-6 t-label text-foreground-800 px-1.5 py-0.5">{tag}</span>}
      {caption && (
        <div className="window-cap px-cell py-3.5 t-label text-foreground-700">
          <span>{caption}</span>
          {meta && <span className="text-accent-700 whitespace-nowrap">{meta}</span>}
        </div>
      )}
    </div>
  );
}

export function SectionLabel({ index, children, dark = false }: { index: string; children: ReactNode; dark?: boolean }) {
  return (
    <p className={`t-label flex items-center gap-3 reveal ${dark ? 'text-background-400' : 'text-foreground-600'}`}>
      <span className="text-accent-700 data-[dark=true]:text-accent-500" data-dark={dark}>{index}</span>
      <span className={`h-px w-6 ${dark ? 'bg-background-50/25' : 'bg-foreground-950/20'}`} />
      <span>{children}</span>
    </p>
  );
}